import {
  GET_COMBO_NGUON_KHACH_HANG,
  GET_COMBO_NGUON_KHACH_HANG_SUCCESS,
  GET_COMBO_NGUON_KHACH_HANG_FAILURE,
} from "actions/NguonKhachHang/actionTypes";

const initialState = {
  loaiTaiSanLoading: false,
  comboNguonKhachHang: [],
  comboNguonKhachHangLoaded: false,
};

const getComboNguonKhachHang = (state, action) => ({
  ...state,
  loaiTaiSanLoading: true,
  comboNguonKhachHangLoaded: true,
});

const getComboNguonKhachHangSuccess = (state, action) => {
  return {
    ...state,
    loaiTaiSanLoading: false,
    comboNguonKhachHang: action.payload,
    comboNguonKhachHangLoaded: true,
  };
};

const getComboNguonKhachHangFailed = (state, action) => ({
  ...state,
  loaiTaiSanLoading: false,
  comboNguonKhachHang: [],
  comboNguonKhachHangLoaded: true,
});
const nguonKhachHangReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_COMBO_NGUON_KHACH_HANG:
      return getComboNguonKhachHang(state, action);
    case GET_COMBO_NGUON_KHACH_HANG_SUCCESS:
      return getComboNguonKhachHangSuccess(state, action);
    case GET_COMBO_NGUON_KHACH_HANG_FAILURE:
      return getComboNguonKhachHangFailed(state, action);
    default:
      return state;
  }
};

export default nguonKhachHangReducer;
